export const posts = [
    {
        id: 1,
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque justo eu vulputate mollis. Suspendisse vel pharetra justo. Integer ornare sagittis blandit. Sed tristique gravida eros.',
        username: 'Jane Doe',
        time: '4 hours ago',
        comments: [
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent elementum ultricies enim.',
                username: 'John Smith',
                time: "12 hours ago"
            },
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam imperdiet diam eget accumsan tempus. Maecenas accumsan augue eu.',
                username: 'Geddy Lee',
                time: "3 hours ago"
            },
        ],
    },
    {
        id: 2,
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque justo eu vulputate mollis. Suspendisse vel pharetra justo. Integer ornare sagittis blandit. Sed tristique gravida eros.',
        username: 'Jane Doe',
        time: '4 hours ago',
        comments: [
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent elementum ultricies enim.',
                username: 'John Smith',
                time: "12 hours ago"
            },
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam imperdiet diam eget accumsan tempus. Maecenas accumsan augue eu.',
                username: 'Geddy Lee',
                time: "3 hours ago"
            },
        ],
    },
    {
        id: 3,
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque justo eu vulputate mollis. Suspendisse vel pharetra justo. Integer ornare sagittis blandit. Sed tristique gravida eros.',
        username: 'Jane Doe',
        time: '4 hours ago',
        comments: [
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent elementum ultricies enim.',
                username: 'John Smith',
                time: "12 hours ago"
            },
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam imperdiet diam eget accumsan tempus. Maecenas accumsan augue eu.',
                username: 'Geddy Lee',
                time: "3 hours ago"
            },
        ],
    },
    {
        id: 4,
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque justo eu vulputate mollis. Suspendisse vel pharetra justo. Integer ornare sagittis blandit. Sed tristique gravida eros.',
        username: 'Jane Doe',
        time: '4 hours ago',
        comments: [
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent elementum ultricies enim.',
                username: 'John Smith',
                time: "12 hours ago"
            },
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam imperdiet diam eget accumsan tempus. Maecenas accumsan augue eu.',
                username: 'Geddy Lee',
                time: "3 hours ago"
            },
        ],
    },
    {
        id: 5,
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque justo eu vulputate mollis. Suspendisse vel pharetra justo. Integer ornare sagittis blandit. Sed tristique gravida eros.',
        username: 'Jane Doe',
        time: '4 hours ago',
        comments: [
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent elementum ultricies enim.',
                username: 'John Smith',
                time: "12 hours ago"
            },
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam imperdiet diam eget accumsan tempus. Maecenas accumsan augue eu.',
                username: 'Geddy Lee',
                time: "3 hours ago"
            },
        ],
    },
    {
        id: 6,
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque justo eu vulputate mollis. Suspendisse vel pharetra justo. Integer ornare sagittis blandit. Sed tristique gravida eros.',
        username: 'Jane Doe',
        time: '4 hours ago',
        comments: [
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent elementum ultricies enim.',
                username: 'John Smith',
                time: "12 hours ago"
            },
            {
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam imperdiet diam eget accumsan tempus. Maecenas accumsan augue eu.',
                username: 'Geddy Lee',
                time: "3 hours ago"
            },
        ],
    },
];

export const industries = [
    { value: 'homeImprovement', label: 'Home Improvement'},
    { value: 'insurance', label: 'Insurance'},
    { value: 'automotive', label: 'Automotive'},
];

export const hours = {
    monday: {
        start: '09:00 AM',
        end: '05:00 PM',
        closed: false,
    },
    tuesday: {
        start: null,
        end: null,
        closed: false,
    },
    wednesday: {
        start: null,
        end: null,
        closed: true,
    },
    thursday: {
        start: '08:00 AM',
        end: "10:00 PM",
        closed: false,
    },
    friday: {
        start: '09:00 AM',
        end: '05:00 PM',
        closed: false
    },
    saturday: {
        start: null,
        end: null,
        closed: true,
    },
    sunday: {
        start: null,
        end: null,
        closed: true
    },
};